import { unLockScreenScroll } from "../utils/treatment";

const arrMenuInfo = new Array();

export function sidebarMenu (menu) {
  const menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((menu, index) => {
    let textDefault = menu.querySelector('span').innerText;
    let iconDefault = menu.querySelector('i').classList[0]
    arrMenuInfo.push({text: textDefault, icon: iconDefault})

    menu.addEventListener('click', () => {
      menu.classList.contains('active')
        ? closeTarget(menu, arrMenuInfo[index].text, arrMenuInfo[index].icon)
        : openTarget(menu)
    })
  })
}

export function openTargetOnScroll(menuClass) {
  let menu = document.querySelector(menuClass);
  if (menu)  {
    let text = menu.querySelector('span').innerText;
    let icon = menu.querySelector('i').classList[0];
    const pageURLParameter = window.location.pathname;
    const parameters = ['/novos', '/test-drive', '/vendas-diretas', '/despachante'];
    if (!parameters.includes(pageURLParameter)) {
      openTarget(menu);

      window.addEventListener('scroll', () => {
        if(window.innerWidth >= 992) {
          if (window.scrollY > 500 ) {
            if(menu.classList.contains('active')) {
              closeTarget(menu, text, icon)
            }
          }
          else {
            if(!menu.classList.contains('active')) {
              openTarget(menu)
            }
          }
        }
      })
    }
  }
}

export function openTarget(menu) {
  if(menu) {
    closeSidebarFixed();
    menu.classList.add('active');
    menu.querySelector('span').innerText = 'Fechar'
    menu.querySelector('i').className = '';
    menu.querySelector('i').classList.add('icon-fechar');
    document.querySelector(menu.dataset.target).classList.add('opened')
  } 
}



export function closeTarget(menu, textDefault, iconDefault) {
  menu.classList.remove('active');
  menu.querySelector('span').innerText = textDefault;
  menu.querySelector('i').classList.remove('icon-fechar');
  menu.querySelector('i').classList.add(iconDefault);
  document.querySelector(menu.dataset.target).classList.remove('opened')
  unLockScreenScroll()
}


function closeSidebarFixed() {
  const openedMenu = document.querySelector('.js-sidebar-button.active') 
  if(openedMenu) {
    openedMenu.classList.remove('active');
    openedMenu.querySelector('i').classList.remove('icon-fechar')
    openedMenu.querySelector('i').classList.add('icon-menu')
    openedMenu.querySelector('span').innerText = "Menu"
    document.querySelector('.js-sidebar-container').classList.toggle('d-flex');
    unLockScreenScroll();
  }
}

export function closeOpenedSideBarMenu() {
  const openedMenu = document.querySelectorAll('.js-sidebar-menu')
  openedMenu.forEach((menu, index) => {
    if(menu.classList.contains('active')) {
      closeTarget(menu, arrMenuInfo[index].text, arrMenuInfo[index].icon)
    }
  })
}